/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listen_To_SoundtrackInputs */

const en_listen_to_soundtrack = /** @type {(inputs: Listen_To_SoundtrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen to Soundtrack`)
};

/** @type {(inputs: Listen_To_SoundtrackInputs) => LocalizedString} */
const es_listen_to_soundtrack = en_listen_to_soundtrack;

/** @type {(inputs: Listen_To_SoundtrackInputs) => LocalizedString} */
const fr_listen_to_soundtrack = en_listen_to_soundtrack;

/** @type {(inputs: Listen_To_SoundtrackInputs) => LocalizedString} */
const de_listen_to_soundtrack = en_listen_to_soundtrack;

/** @type {(inputs: Listen_To_SoundtrackInputs) => LocalizedString} */
const ja_listen_to_soundtrack = en_listen_to_soundtrack;

/** @type {(inputs: Listen_To_SoundtrackInputs) => LocalizedString} */
const zh_listen_to_soundtrack = en_listen_to_soundtrack;

/** @type {(inputs: Listen_To_SoundtrackInputs) => LocalizedString} */
const ar_listen_to_soundtrack = en_listen_to_soundtrack;

/** @type {(inputs: Listen_To_SoundtrackInputs) => LocalizedString} */
const id_listen_to_soundtrack = en_listen_to_soundtrack;

/** @type {(inputs: Listen_To_SoundtrackInputs) => LocalizedString} */
const it_listen_to_soundtrack = en_listen_to_soundtrack;

/** @type {(inputs: Listen_To_SoundtrackInputs) => LocalizedString} */
const ru_listen_to_soundtrack = en_listen_to_soundtrack;

/** @type {(inputs: Listen_To_SoundtrackInputs) => LocalizedString} */
const pt_listen_to_soundtrack = en_listen_to_soundtrack;

/** @type {(inputs: Listen_To_SoundtrackInputs) => LocalizedString} */
const ko_listen_to_soundtrack = en_listen_to_soundtrack;

/**
* | output |
* | --- |
* | "Listen to Soundtrack" |
*
* @param {Listen_To_SoundtrackInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listen_to_soundtrack = /** @type {((inputs?: Listen_To_SoundtrackInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listen_To_SoundtrackInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listen_to_soundtrack(inputs)
	if (locale === "es") return es_listen_to_soundtrack(inputs)
	if (locale === "fr") return fr_listen_to_soundtrack(inputs)
	if (locale === "de") return de_listen_to_soundtrack(inputs)
	if (locale === "ja") return ja_listen_to_soundtrack(inputs)
	if (locale === "zh") return zh_listen_to_soundtrack(inputs)
	if (locale === "ar") return ar_listen_to_soundtrack(inputs)
	if (locale === "id") return id_listen_to_soundtrack(inputs)
	if (locale === "it") return it_listen_to_soundtrack(inputs)
	if (locale === "ru") return ru_listen_to_soundtrack(inputs)
	if (locale === "pt") return pt_listen_to_soundtrack(inputs)
	return ko_listen_to_soundtrack(inputs)
});